// removed by extract-text-webpack-plugin
module.exports = {"snapSellPackagePage":"_2xopotdAJPkXKWvB67qCF9"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/containers/SnapSellPackagePage.scss
// module id = 1585
// module chunks = 0